<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>E-TIMS Configs Setup</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-btn @click="computeAmayaBalance" color="primary" :loading="loader">Compute Amaya Opening
                            Balances</v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="8">
                        <v-row>

                            <v-col cols="12" xs="12" sm="12" md="6">
                                <v-text-field label="KRA PIN" v-model="record.KraPin" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="6">
                                <v-text-field label="Etims Branch Id" v-model="record.EtimsBranchId" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Etims Api Key" v-model="record.EtimsApiKey" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Products Api" v-model="record.EtimsProductsApi" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Save Sale" v-model="record.EtimsSaleApi" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Save Stock Items Api" v-model="record.SaveStockItemsApi" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Save Stock Master Api" v-model="record.StockMasterApi" outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="QR Code Api" v-model="record.EtimsQrCodeApi" outlined
                                    dense></v-text-field>
                            </v-col>


                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-text-field label="Scu Id" v-model="record.ScuId" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-radio-group dense label="Etims Integrated" v-model="record.EtimsIntegrated" row>
                                    <v-radio label="Yes" value="Y"></v-radio>
                                    <v-radio label="No" value="N"></v-radio>
                                </v-radio-group>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12">
                                <v-btn class="primary float-right" @click="save" :loading="loader">Update
                                    Settings</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        }
    },
    data() {
        return {
            record: {},
            loader: false,
        };
    },
    methods: {
        save() {
            const data = this.record;
            data.storeId = parseInt(this.activeStore);
            const self = this;
            self.loader = true;
            const url = "/store-config-etims";
            this.$store
                .dispatch("put", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        this.$refs.snackbar.show("Update successful", "green");
                        self.getEtimsSettings();
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getEtimsSettings() {
            const self = this;
            var storeId = this.activeStore;
            this.$store
                .dispatch("get", `/store-config-etims/${storeId}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.record = res.ResponseData;
                        //  self.$store.commit("loader", false);
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        computeAmayaBalance() {
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("get", `/compute-amaya-opening-balance`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.record = res.ResponseData;
                        //  self.$store.commit("loader", false);
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        this.getEtimsSettings();
    },
};
</script>

<style lang="scss" scoped></style>